import PageTitle from '../../components/pagetitle/PageTitle'

import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'

import simag from '../../images/service/h.jpg'
import Gimg1 from '../../images/cta-bg.jpg'
import Gimg2 from '../../images/cta-2.jpg'
import Gimg3 from '../../images/cta-2.jpg'
import Gimg4 from '../../images/cta-4.jpg'


const CargoInsurance = ({ serviceDetails }) => {
    return (
        <>
            <section className={`wpo-breadcumb-area ${serviceDetails.slug}`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            </section>
            <section id='details' className='wpo-service-single-page section-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2 className='mt-0'>{serviceDetails.title}</h2>
                                <div className="title-image">
                                    <img src={simag} alt="" />
                                </div>

                                <p className='mb-3'>
                                    As the saying goes, “It’s better to be safe than sorry.”
                                    Our comprehensive cargo insurance covers both onshore and offshore property and cargo loss or damage across all modes of transportation. Overflow Logistics’ cargo insurance program is a leading professional risk management tool. We pride ourselves on offering our customers fantastic rates, extensive coverage, and quick turnaround times.
                                </p>
                                <p>
                                    We effectively address your risk exposure, whether shipping overseas or importing/exporting general merchandise. Our dedicated Risk Management team provides competitive rates for global risk insurance coverage. Overflow Logistics offers expert advice on insurance services for all types of cargo, including household goods, personal effects, and commercial goods.
                                </p>

                                <div className="row fc-gray my-4 pb-3">
                                    <h5>Our Services Include:</h5>
                                    <ul className="list-unstyled mt-3 fs-6">
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            “All risk” Cargo and Marine Insurance
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Auto Transportation Cover
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            High-Value Goods and Fine Art Transport Cover
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Houshold Goods and Personal Effect Transportation Cover
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            3rd Party Liability Coverage Professional liability Coverage
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Professional Cargo surveying
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Pre-shipment inspection
                                        </li>
                                    </ul>
                                </div>

                                <h3 className="quate">
                                    Expert cargo insurance is essential for secure international and domestic shipments, protecting goods against loss or damage, ensuring regulatory compliance, and providing peace of mind while minimizing risks, delays, and unexpected costs.
                                </h3>

                                <div className="image-gallery">
                                    <h2>Eligibility checklist :</h2>
                                    <ul>
                                        <li><img src={Gimg1} alt="" /></li>
                                        <li><img src={Gimg2} alt="" /></li>
                                        <li><img src={Gimg3} alt="" /></li>
                                        <li><img src={Gimg4} alt="" /></li>
                                    </ul>
                                </div>
                                <Accordion />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CargoInsurance